var _symbol, _symbol2, _symbol3, _symbol4, _symbol5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon_star",
    viewBox: "0 0 168 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f26532",
    style: {
      stroke: "var(--color1, #f26532)"
    },
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M20.909 11.996l8.874 0.807-6.854 6.854 1.729 10.372-8.658-5.195-8.658 5.195 1.729-10.372-6.854-6.854 9.453-0.859 4.33-9.527 4.33 9.527 0.579 0.053zM54.090 11.414l0.241 0.529 9.453 0.859-6.854 6.854 1.729 10.372-8.658-5.195-8.658 5.195 1.729-10.372-6.854-6.854 9.453-0.859 4.33-9.527 4.090 8.997zM88.090 11.414l0.241 0.529 9.453 0.859-6.854 6.854 1.729 10.372-8.658-5.195-8.658 5.195 1.729-10.372-6.854-6.854 9.453-0.859 4.33-9.527 4.090 8.997zM122.090 11.414l0.241 0.529 9.453 0.859-6.854 6.854 1.729 10.372-8.658-5.195-8.658 5.195 1.729-10.372-6.854-6.854 9.453-0.859 4.33-9.527 4.090 8.997zM156.090 11.414l0.241 0.529 9.453 0.859-6.854 6.854 1.729 10.372-8.658-5.195-8.658 5.195 1.729-10.372-6.854-6.854 9.453-0.859 4.33-9.527 4.090 8.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    style: {
      fill: "var(--color2, #f5f5f5)"
    },
    d: "M16 0h-16v32h168v-32h-152zM16 0l5 11 11 1-8 8 2 12-10-6-10 6 2-12-8-8 11-1 5-11zM50 0l5 11 11 1-8 8 2 12-10-6-10 6 2-12-8-8 11-1 5-11zM84 0l5 11 11 1-8 8 2 12-10-6-10 6 2-12-8-8 11-1 5-11zM118 0l5 11 11 1-8 8 2 12-10-6-10 6 2-12-8-8 11-1 5-11zM152 0l5 11 11 1-8 8 2 12-10-6-10 6 2-12-8-8 11-1 5-11z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_arrow",
    viewBox: "0 0 46 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.435 5.263l-1.979-1.98c-0.686-0.651-1.487-0.976-2.401-0.976-0.933 0-1.725 0.326-2.376 0.976l-12.829 12.829-12.829-12.829c-0.651-0.651-1.443-0.976-2.376-0.976-0.915 0-1.716 0.326-2.402 0.976l-1.953 1.98c-0.669 0.668-1.003 1.469-1.003 2.402 0 0.95 0.335 1.742 1.003 2.376l17.184 17.184c0.634 0.668 1.425 1.003 2.376 1.003 0.933 0 1.734-0.334 2.402-1.003l17.184-17.184c0.651-0.651 0.977-1.443 0.977-2.376 0-0.915-0.326-1.716-0.977-2.402z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_clock",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c-8.823 0-16 7.177-16 16s7.177 16 16 16c8.823 0 16-7.177 16-16s-7.177-16-16-16zM16 29.521c-7.455 0-13.521-6.067-13.521-13.521s6.067-13.521 13.521-13.521c7.456 0 13.521 6.067 13.521 13.521s-6.067 13.521-13.521 13.521zM17.239 15.479l4.462 3.346c0.548 0.41 0.659 1.187 0.248 1.734-0.243 0.327-0.615 0.497-0.993 0.497-0.259 0-0.519-0.081-0.742-0.248l-4.957-3.718c-0.312-0.233-0.496-0.601-0.496-0.991v-7.436c0-0.685 0.554-1.239 1.239-1.239s1.239 0.554 1.239 1.239v6.816z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_email",
    viewBox: "0 0 38 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.678 0c2.33 0.007 4.306 1.785 4.65 4.185l-19.128 12.893-19.128-12.893c0.345-2.4 2.32-4.178 4.65-4.185h28.956zM0 7.315l18.505 12.472c0.423 0.285 0.967 0.285 1.39 0l18.505-12.473v19.768c-0.003 2.715-2.115 4.916-4.722 4.919h-28.956c-2.607-0.003-4.719-2.203-4.722-4.919v-19.767z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_phone",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.971 23.040c-0.087-0.069-6.437-4.646-8.18-4.318-0.832 0.147-1.308 0.715-2.262 1.851-0.154 0.183-0.523 0.623-0.81 0.935-0.603-0.197-1.192-0.436-1.761-0.717-2.938-1.43-5.312-3.804-6.742-6.742-0.281-0.569-0.52-1.158-0.717-1.761 0.314-0.288 0.753-0.657 0.941-0.815 1.131-0.949 1.699-1.425 1.846-2.259 0.302-1.728-4.272-8.122-4.32-8.179-0.42-0.6-1.088-0.98-1.819-1.035-1.854 0-7.147 6.866-7.147 8.022 0 0.067 0.097 6.898 8.521 15.467 8.56 8.414 15.39 8.511 15.457 8.511 1.157 0 8.022-5.293 8.022-7.147-0.054-0.728-0.432-1.394-1.029-1.813z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon_pin",
    viewBox: "0 0 24 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c-6.616 0-12 5.421-12 12.087 0 9.471 10.872 19.249 11.335 19.66 0.191 0.169 0.428 0.253 0.665 0.253s0.475-0.084 0.665-0.252c0.463-0.412 11.335-10.191 11.335-19.661 0-6.665-5.384-12.087-12-12.087zM12 18.667c-3.676 0-6.667-2.991-6.667-6.667s2.991-6.667 6.667-6.667c3.676 0 6.667 2.991 6.667 6.667s-2.991 6.667-6.667 6.667z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 80 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0880ae",
    style: {
      fill: "var(--color3, #0880ae)"
    },
    d: "M16.093 32c-8.889 0-16.093-7.343-16.093-16.404v-15.596c8.889 0 16.093 7.343 16.093 16.404v15.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f26532",
    style: {
      fill: "var(--color1, #f26532)"
    },
    d: "M17.497 18.728v-8.286c0-5.76 4.593-10.442 10.26-10.442v8.286c0 5.76-4.593 10.442-10.26 10.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0880ae",
    style: {
      fill: "var(--color3, #0880ae)"
    },
    d: "M40.678 32h-11.764c-6.312 0-11.417-5.204-11.417-11.638h11.764c6.312 0 11.417 5.204 11.417 11.638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M37.718 14.103l-3.059-4.065v4.065h-2.217v-9.205h2.217v4.039l3.034-4.039h2.606l-3.526 4.511 3.656 4.694h-2.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M49.364 4.899v9.205h-2.217v-3.789h-3.448v3.789h-2.217v-9.205h2.217v3.606h3.448v-3.606h2.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M56.629 12.477h-3.397l-0.544 1.626h-2.321l3.293-9.205h2.567l3.293 9.205h-2.347l-0.544-1.626zM56.059 10.747l-1.128-3.37-1.115 3.37h2.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M68.664 14.103h-2.217l-3.707-5.678v5.678h-2.217v-9.205h2.217l3.707 5.704v-5.704h2.217v9.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M48.825 18.652v0.761h-2.515v8.405h-0.907v-8.405h-2.528v-0.761h5.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M52.974 19.4v3.422h3.435v0.761h-3.435v3.475h3.824v0.761h-4.732v-9.178h4.732v0.761h-3.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M59.979 23.228c0-0.9 0.194-1.705 0.583-2.413 0.389-0.717 0.921-1.272 1.595-1.665 0.674-0.402 1.426-0.603 2.256-0.603 1.011 0 1.875 0.245 2.593 0.734 0.726 0.481 1.253 1.163 1.582 2.046h-1.063c-0.259-0.621-0.657-1.106-1.193-1.456-0.527-0.35-1.167-0.524-1.918-0.524-0.666 0-1.266 0.157-1.802 0.472-0.527 0.315-0.942 0.769-1.245 1.364-0.302 0.586-0.454 1.267-0.454 2.046s0.151 1.46 0.454 2.046c0.302 0.586 0.717 1.036 1.245 1.351 0.536 0.315 1.137 0.472 1.802 0.472 0.751 0 1.391-0.17 1.918-0.511 0.536-0.35 0.934-0.83 1.193-1.442h1.063c-0.329 0.874-0.856 1.552-1.582 2.032s-1.59 0.721-2.593 0.721c-0.83 0-1.582-0.197-2.256-0.59-0.674-0.402-1.206-0.957-1.595-1.665s-0.583-1.512-0.583-2.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    style: {
      fill: "var(--color4, #252525)"
    },
    d: "M78.932 18.652v9.165h-0.907v-4.288h-4.914v4.288h-0.907v-9.165h0.907v4.117h4.914v-4.117h0.907z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.219b81d4db9f79d27fee58468ef78c4f.svg";
export { ForwardRef as ReactComponent };